var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/fonts/GillSansProCyrillic-Bold.woff": "7845",
	"./assets/fonts/GillSansProCyrillic-Bold.woff2": "612d",
	"./assets/fonts/GillSansProCyrillic-Light.woff": "3d46",
	"./assets/fonts/GillSansProCyrillic-Light.woff2": "d559",
	"./assets/fonts/GillSansProCyrillic-Medium.woff": "1be6",
	"./assets/fonts/GillSansProCyrillic-Medium.woff2": "5d91",
	"./assets/fonts/Oranienbaum.woff": "7c9f",
	"./assets/fonts/Oranienbaum.woff2": "cb9e",
	"./assets/img/404.svg": "8e71",
	"./assets/img/404m.svg": "a5d5",
	"./assets/img/aem/aem.jpg": "81e6",
	"./assets/img/aem/aem_bg.svg": "a169",
	"./assets/img/aem/aem_en.svg": "38e9",
	"./assets/img/aquapark/bg.jpg": "f0cf",
	"./assets/img/aquapark/message/desktop-bg.png": "7c07",
	"./assets/img/aquapark/message/desktop-en.png": "f770",
	"./assets/img/aquapark/message/mob-bg.png": "148e",
	"./assets/img/aquapark/message/mob-en.png": "5374",
	"./assets/img/aquapark/s1-1.jpg": "c984",
	"./assets/img/aquapark/s1-2.jpg": "6276",
	"./assets/img/aquapark/s1-3.jpg": "4c74",
	"./assets/img/aquapark/s2-1.jpg": "8c03",
	"./assets/img/aquapark/s2-2.jpg": "2001",
	"./assets/img/aquapark/s2-3.jpg": "ef8d",
	"./assets/img/aquapark/s3-1.jpg": "1d97",
	"./assets/img/aquapark/s3-2.jpg": "7a96",
	"./assets/img/aquapark/s3-3.jpg": "d706",
	"./assets/img/aquapark/svg_bg.svg": "556a",
	"./assets/img/aquapark/svg_en.svg": "8862",
	"./assets/img/aquapark/table1-bg.svg": "db0e",
	"./assets/img/aquapark/table1-en.svg": "8771",
	"./assets/img/banya/ban1-bg.svg": "4fd8",
	"./assets/img/banya/ban1-en.svg": "dcae",
	"./assets/img/banya/ban2-bg.svg": "1140",
	"./assets/img/banya/ban2-en.svg": "19fa",
	"./assets/img/banya/ban3-bg.svg": "469b",
	"./assets/img/banya/ban3-en.svg": "3f22",
	"./assets/img/banya/bg.jpg": "0492",
	"./assets/img/banya/bg_bg.jpg": "adbf",
	"./assets/img/banya/bg_en.jpg": "e6c5",
	"./assets/img/banya/s1-1.webp": "95ce",
	"./assets/img/banya/s1-2.webp": "c3ae",
	"./assets/img/banya/s1-3.webp": "0a13",
	"./assets/img/banya/s2-1.webp": "c204",
	"./assets/img/banya/s2-2.webp": "8ded",
	"./assets/img/banya/s2-3.webp": "0173",
	"./assets/img/banya/s3-1.webp": "7e7f",
	"./assets/img/banya/s3-2.webp": "9264",
	"./assets/img/banya/s3-3.webp": "25bb",
	"./assets/img/banya/svg_bg.svg": "dc18",
	"./assets/img/banya/svg_en.svg": "16c7",
	"./assets/img/bg.jpg": "d1b4",
	"./assets/img/close.svg": "1d1b",
	"./assets/img/contacts/contacts.jpg": "9a97",
	"./assets/img/contacts/contacts_bg.svg": "2399",
	"./assets/img/contacts/contacts_en.svg": "1ba1",
	"./assets/img/contacts/map1_bg.svg": "641e",
	"./assets/img/contacts/map1_en.svg": "71d6",
	"./assets/img/contacts/map2_bg.svg": "e2af",
	"./assets/img/contacts/map2_en.svg": "a311",
	"./assets/img/dd.svg": "406d",
	"./assets/img/footer/banya-text_bg.svg": "52bb",
	"./assets/img/footer/banya-text_en.svg": "d62b",
	"./assets/img/footer/booking.svg": "bb9e",
	"./assets/img/footer/f1_bg.svg": "b215",
	"./assets/img/footer/f1_en.svg": "3eef",
	"./assets/img/footer/f2_bg.svg": "6fef",
	"./assets/img/footer/f2_en.svg": "9174",
	"./assets/img/footer/f3_bg.svg": "cf77",
	"./assets/img/footer/f3_en.svg": "3962",
	"./assets/img/footer/f4_bg.svg": "c717",
	"./assets/img/footer/f4_en.svg": "4ad4",
	"./assets/img/footer/f5_bg.svg": "89a6",
	"./assets/img/footer/f5_en.svg": "23b3",
	"./assets/img/footer/f6_bg.svg": "fed70",
	"./assets/img/footer/f6_en.svg": "9dd6",
	"./assets/img/footer/f7_bg.svg": "74b4",
	"./assets/img/footer/f7_en.svg": "575c",
	"./assets/img/footer/f8_bg.svg": "f70f",
	"./assets/img/footer/f8_en.svg": "104d",
	"./assets/img/footer/f9_bg.svg": "69ce",
	"./assets/img/footer/f9_en.svg": "d870",
	"./assets/img/footer/fb.svg": "9d62",
	"./assets/img/footer/ftr-bl.png": "9c73",
	"./assets/img/footer/ftr.png": "f402",
	"./assets/img/footer/ig.svg": "eacc",
	"./assets/img/footer/mail.svg": "370a",
	"./assets/img/footer/payment.svg": "fb91",
	"./assets/img/footer/phone.svg": "7ead",
	"./assets/img/footer/r.svg": "8583",
	"./assets/img/footer/ta.svg": "53e0",
	"./assets/img/footer/tw.svg": "65e9",
	"./assets/img/gallery/gallery-desktop-hover.png": "52bd",
	"./assets/img/gallery/gallery-desktop.png": "5c58",
	"./assets/img/gallery/gallery-mobile.png": "3a33",
	"./assets/img/gallery/svg_bg.svg": "9294",
	"./assets/img/gallery/svg_en.svg": "b4d9",
	"./assets/img/gift-voucher/bg.jpg": "53ee",
	"./assets/img/gift-voucher/img-bg.png": "aadd",
	"./assets/img/gift-voucher/img-bg.svg": "9358",
	"./assets/img/gift-voucher/svg_bg.svg": "9ba4",
	"./assets/img/gift-voucher/svg_en.svg": "f7e6",
	"./assets/img/gift/bg.jpg": "b96a",
	"./assets/img/gift/svg_bg.svg": "0d8d",
	"./assets/img/gift/svg_en.svg": "8aeb",
	"./assets/img/halls/1/a1.jpg": "29a4",
	"./assets/img/halls/1/a2.jpg": "0248",
	"./assets/img/halls/1/a3.jpg": "f99c",
	"./assets/img/halls/1/bg.jpg": "c0f6",
	"./assets/img/halls/1/capacity_bg.svg": "2ad6",
	"./assets/img/halls/1/capacity_en.svg": "2fd6",
	"./assets/img/halls/1/g1.jpg": "c79e",
	"./assets/img/halls/1/g2.jpg": "bb9a",
	"./assets/img/halls/1/hall-str.svg": "5cc8",
	"./assets/img/halls/1/svg_bg.svg": "cf23",
	"./assets/img/halls/1/svg_en.svg": "1b1b",
	"./assets/img/halls/2/a1.jpg": "86e5",
	"./assets/img/halls/2/a2.jpg": "fa21",
	"./assets/img/halls/2/a3.jpg": "8f5d",
	"./assets/img/halls/2/bg.jpg": "36eb",
	"./assets/img/halls/2/capacity_bg.svg": "5252",
	"./assets/img/halls/2/capacity_en.svg": "0383",
	"./assets/img/halls/2/g1.jpg": "8531",
	"./assets/img/halls/2/g2.jpg": "52fc",
	"./assets/img/halls/2/g3.jpg": "58a3",
	"./assets/img/halls/2/g4.jpg": "8fb4",
	"./assets/img/halls/2/g5.jpg": "c53b",
	"./assets/img/halls/2/hall-str.svg": "ca43",
	"./assets/img/halls/2/svg_bg.svg": "722f",
	"./assets/img/halls/2/svg_en.svg": "28b6",
	"./assets/img/halls/3/a1.jpg": "c5fa",
	"./assets/img/halls/3/a2.jpg": "f6b2",
	"./assets/img/halls/3/a3.jpg": "6a7a",
	"./assets/img/halls/3/bg.jpg": "df8d",
	"./assets/img/halls/3/capacity_bg.svg": "a4e0",
	"./assets/img/halls/3/capacity_en.svg": "1433",
	"./assets/img/halls/3/g1.jpg": "e2e4",
	"./assets/img/halls/3/g2.jpg": "c801",
	"./assets/img/halls/3/hall-str.svg": "3397",
	"./assets/img/halls/3/svg_bg.svg": "5f64",
	"./assets/img/halls/3/svg_en.svg": "77d4",
	"./assets/img/halls/4/a1.jpg": "7360",
	"./assets/img/halls/4/a2.jpg": "5746",
	"./assets/img/halls/4/a3.jpg": "c1c5",
	"./assets/img/halls/4/bg.jpg": "0820",
	"./assets/img/halls/4/capacity_bg.svg": "80db",
	"./assets/img/halls/4/capacity_en.svg": "87d5",
	"./assets/img/halls/4/g1.jpg": "a4ec",
	"./assets/img/halls/4/g10.jpg": "3c60",
	"./assets/img/halls/4/g11.jpg": "a51e",
	"./assets/img/halls/4/g2.jpg": "bd73",
	"./assets/img/halls/4/g3.jpg": "8efe",
	"./assets/img/halls/4/g4.jpg": "972a",
	"./assets/img/halls/4/g5.jpg": "8cb5",
	"./assets/img/halls/4/g6.jpg": "f70a",
	"./assets/img/halls/4/g7.jpg": "5b47",
	"./assets/img/halls/4/g8.jpg": "0f48",
	"./assets/img/halls/4/g9.jpg": "49fc",
	"./assets/img/halls/4/hall-str.svg": "81f6",
	"./assets/img/halls/4/svg_bg.svg": "65f2",
	"./assets/img/halls/4/svg_en.svg": "7c6b",
	"./assets/img/halls/5/a1.jpg": "f89e",
	"./assets/img/halls/5/a2.jpg": "e921",
	"./assets/img/halls/5/a3.jpg": "a7a0",
	"./assets/img/halls/5/bg.jpg": "f843",
	"./assets/img/halls/5/capacity_bg.svg": "7404",
	"./assets/img/halls/5/capacity_en.svg": "44fe",
	"./assets/img/halls/5/g1.jpg": "05b7",
	"./assets/img/halls/5/g2.jpg": "d970",
	"./assets/img/halls/5/g3.jpg": "eb8c",
	"./assets/img/halls/5/g4.jpg": "c7d6",
	"./assets/img/halls/5/hall-str.svg": "e3236",
	"./assets/img/halls/5/svg_bg.svg": "d789",
	"./assets/img/halls/5/svg_en.svg": "4f7f",
	"./assets/img/halls/features/c1.svg": "f736",
	"./assets/img/halls/features/c2.svg": "8677",
	"./assets/img/halls/features/c3.svg": "34e6",
	"./assets/img/halls/features/c4.svg": "b3df",
	"./assets/img/halls/features/c5.svg": "b554",
	"./assets/img/halls/features/c6.svg": "0804",
	"./assets/img/halls/features/h1.svg": "3414",
	"./assets/img/halls/features/h2.svg": "ee22",
	"./assets/img/halls/features/h3.svg": "4940",
	"./assets/img/halls/features/h4.svg": "fd12",
	"./assets/img/halls/features/h5.svg": "1153",
	"./assets/img/halls/features/h6.svg": "5687",
	"./assets/img/halls/svg_bg.svg": "4953",
	"./assets/img/halls/svg_en.svg": "f23e",
	"./assets/img/home/about/bg_mask_bg.svg": "0b3f",
	"./assets/img/home/about/bg_mask_en.svg": "dfc7",
	"./assets/img/home/about/eu_mask_bg.svg": "25e5",
	"./assets/img/home/about/eu_mask_en.svg": "9c63",
	"./assets/img/home/parallax/b-bg.svg": "4e55",
	"./assets/img/home/parallax/b-en.svg": "aef2",
	"./assets/img/home/parallax/banya_bg.jpg": "bae8",
	"./assets/img/home/parallax/home3_bg.jpg": "4d63",
	"./assets/img/home/parallax/spa-bg.svg": "dc16",
	"./assets/img/home/parallax/spa-en.svg": "cea8",
	"./assets/img/home/parallax/video.mp4": "f7445",
	"./assets/img/img-left.svg": "a6dc",
	"./assets/img/img-right.svg": "2f5c",
	"./assets/img/kids/bg.jpg": "322e",
	"./assets/img/kids/s1-1.jpeg": "a903",
	"./assets/img/kids/s1-10.jpeg": "df14",
	"./assets/img/kids/s1-11.jpeg": "6cfe",
	"./assets/img/kids/s1-12.jpeg": "281b",
	"./assets/img/kids/s1-13.jpeg": "31be",
	"./assets/img/kids/s1-14.jpeg": "e463",
	"./assets/img/kids/s1-15.jpeg": "741f",
	"./assets/img/kids/s1-16.jpeg": "84a1",
	"./assets/img/kids/s1-2.jpeg": "79f8",
	"./assets/img/kids/s1-3.jpeg": "75ce",
	"./assets/img/kids/s1-4.jpeg": "74f8",
	"./assets/img/kids/s1-5.jpeg": "54f6",
	"./assets/img/kids/s1-6.jpeg": "a8ae",
	"./assets/img/kids/s1-7.jpeg": "16be",
	"./assets/img/kids/s1-8.jpeg": "757d",
	"./assets/img/kids/s1-9.jpeg": "85c4",
	"./assets/img/kids/svg_bg.svg": "b655",
	"./assets/img/kids/svg_en.svg": "401e",
	"./assets/img/l.svg": "07cf",
	"./assets/img/left.svg": "0182",
	"./assets/img/left_white.svg": "b661",
	"./assets/img/logo.svg": "1ae4",
	"./assets/img/logo_black.svg": "69fa",
	"./assets/img/loyal/bg.jpg": "1921",
	"./assets/img/loyal/s1-1.jpg": "fd40",
	"./assets/img/loyal/s1-2.jpg": "4f4b",
	"./assets/img/loyal/s1-3.jpg": "e18a",
	"./assets/img/loyal/s2-1.jpg": "fbe8",
	"./assets/img/loyal/s2-2.jpg": "b409",
	"./assets/img/loyal/s2-3.jpg": "0d2b",
	"./assets/img/loyal/svg_bg.svg": "9dd9",
	"./assets/img/loyal/svg_en.svg": "403f",
	"./assets/img/menus/a_la_carte.jpg": "b974",
	"./assets/img/menus/a_la_carte.png": "5527",
	"./assets/img/menus/aquapark.jpg": "4bf5",
	"./assets/img/menus/aquapark.png": "9d52",
	"./assets/img/menus/lobby_bar.jpg": "4a56",
	"./assets/img/menus/lobby_bar.png": "4e45",
	"./assets/img/menus/room_service.jpg": "34bd",
	"./assets/img/menus/room_service.png": "69dc",
	"./assets/img/menus/spa.jpg": "d386",
	"./assets/img/menus/spa.png": "472f",
	"./assets/img/menus/wine_list.jpg": "146b",
	"./assets/img/menus/wine_list.png": "95a2",
	"./assets/img/new-year-modal/close.svg": "8b2d",
	"./assets/img/new-year-modal/desktop-bg.png": "f5c3",
	"./assets/img/new-year-modal/desktop-en.png": "53e8",
	"./assets/img/new-year-modal/mob-bg.png": "7967",
	"./assets/img/new-year-modal/mob-en.png": "7dc7",
	"./assets/img/news/1/bg.jpg": "6c33",
	"./assets/img/news/2/bg.jpg": "6ce8",
	"./assets/img/news/2022-banya/bg.jpg": "e7f6",
	"./assets/img/news/2022-jazz/bg.jpg": "7b5b",
	"./assets/img/news/2022-jazz/jazz-22-bg.jpg": "2087",
	"./assets/img/news/2022-jazz/jazz-22-en.jpg": "540d",
	"./assets/img/news/2022-lift/bg.jpg": "d7a1",
	"./assets/img/news/2022-lift/t1-bg.png": "35aa",
	"./assets/img/news/2022-lift/t1-en.png": "4fa7",
	"./assets/img/news/2022-nye/bg.jpg": "f69f",
	"./assets/img/news/2022-summer/bg.jpg": "b440",
	"./assets/img/news/2022-summer/t2-bg.png": "f654",
	"./assets/img/news/2022-summer/t2-en.png": "85e6",
	"./assets/img/news/2023-banya/bg.jpg": "17ea",
	"./assets/img/news/2023-business-training/bg.jpg": "3bb4",
	"./assets/img/news/2023-nye/bg-.jpg": "287f",
	"./assets/img/news/2023-nye/bg.jpg": "0f3d",
	"./assets/img/news/2023-vip/bg.jpg": "3451",
	"./assets/img/news/2024-Upcoming-Events/bg.jpg": "0ba3",
	"./assets/img/news/2024-el-car-power-stations/bg.jpg": "d6da",
	"./assets/img/news/2024-renovation/bg.jpg": "6c70",
	"./assets/img/news/2024-ski-pass/bg.jpg": "d06d",
	"./assets/img/news/2025-Upcoming-Events/bg.jpg": "d79f",
	"./assets/img/news/2025-renovation/bg.jpg": "e08e",
	"./assets/img/news/3/bg.jpg": "94b8",
	"./assets/img/news/4.jpg": "4553",
	"./assets/img/news/5.jpg": "5d06",
	"./assets/img/news/6.jpg": "2192",
	"./assets/img/news/7/7.jpg": "fa3e",
	"./assets/img/news/8/8.jpg": "fe8d",
	"./assets/img/news/svg_bg.svg": "99ec",
	"./assets/img/news/svg_en.svg": "0d05",
	"./assets/img/nye/bosfor-price_bg.svg": "988e",
	"./assets/img/nye/bosfor-price_en.svg": "21ae",
	"./assets/img/nye/bosfor_bg.svg": "723b",
	"./assets/img/nye/bosfor_en.svg": "aa77",
	"./assets/img/nye/dinner.svg": "f629",
	"./assets/img/nye/fireworks.svg": "cdc7",
	"./assets/img/nye/food-r/1.jpg": "785e",
	"./assets/img/nye/food-r/10.jpg": "565b",
	"./assets/img/nye/food-r/11.jpg": "e7b6",
	"./assets/img/nye/food-r/12.jpg": "ccc3",
	"./assets/img/nye/food-r/13.jpg": "c400",
	"./assets/img/nye/food-r/2.jpg": "a45d",
	"./assets/img/nye/food-r/3.jpg": "28dc",
	"./assets/img/nye/food-r/4.jpg": "44feb",
	"./assets/img/nye/food-r/5.jpg": "d1b5",
	"./assets/img/nye/food-r/6.jpg": "8145",
	"./assets/img/nye/food-r/7.jpg": "f7440",
	"./assets/img/nye/food-r/8.jpg": "8162",
	"./assets/img/nye/food-r/9.jpg": "1fb7",
	"./assets/img/nye/food/1.jpg": "5221",
	"./assets/img/nye/food/2.jpg": "c5a9",
	"./assets/img/nye/food/3.jpg": "9fe0",
	"./assets/img/nye/food/4.jpg": "efb0",
	"./assets/img/nye/food/5.jpg": "91cb",
	"./assets/img/nye/food/6.jpg": "5a34",
	"./assets/img/nye/food/7.jpg": "ee7d",
	"./assets/img/nye/home-b.mp4": "9230",
	"./assets/img/nye/home-r.mp4": "4161",
	"./assets/img/nye/img.jpg": "0e3d",
	"./assets/img/nye/img1.jpg": "56f3",
	"./assets/img/nye/img_bg.png": "c4dd",
	"./assets/img/nye/img_en.png": "5c78",
	"./assets/img/nye/nye-b.mp4": "f500",
	"./assets/img/nye/nye-r.mp4": "0d53",
	"./assets/img/nye/nye_bg.svg": "ac80",
	"./assets/img/nye/nye_en.svg": "4439",
	"./assets/img/nye/price_bg.svg": "2278",
	"./assets/img/nye/price_en.svg": "a913",
	"./assets/img/nye/program-2024/1.jpg": "249c",
	"./assets/img/nye/program-2024/2.jpg": "2208",
	"./assets/img/nye/program-2024/3.jpg": "55fc",
	"./assets/img/nye/program-2024/5.jpg": "15b8",
	"./assets/img/nye/program-2024/6.jpg": "840b",
	"./assets/img/nye/program-2025/2025-1.jpg": "45bd",
	"./assets/img/nye/program-2025/2025-10.jpg": "3770",
	"./assets/img/nye/program-2025/2025-11.jpg": "b70e",
	"./assets/img/nye/program-2025/2025-12.jpg": "614f",
	"./assets/img/nye/program-2025/2025-13.jpg": "431e",
	"./assets/img/nye/program-2025/2025-14.jpg": "130d",
	"./assets/img/nye/program-2025/2025-15.jpg": "cdbb",
	"./assets/img/nye/program-2025/2025-2.jpg": "e849",
	"./assets/img/nye/program-2025/2025-3.jpg": "1a59",
	"./assets/img/nye/program-2025/2025-4.jpg": "5cb1",
	"./assets/img/nye/program-2025/2025-5.jpg": "022c",
	"./assets/img/nye/program-2025/2025-6.jpg": "4633",
	"./assets/img/nye/program-2025/2025-7.jpg": "2cfe",
	"./assets/img/nye/program-2025/2025-8.jpg": "d804",
	"./assets/img/nye/program-2025/2025-9.jpg": "0243",
	"./assets/img/nye/program/1.jpg": "524a",
	"./assets/img/nye/program/10.jpg": "9964",
	"./assets/img/nye/program/11.jpg": "98fc",
	"./assets/img/nye/program/12.jpg": "637d",
	"./assets/img/nye/program/13.jpg": "280e",
	"./assets/img/nye/program/14.jpg": "c699",
	"./assets/img/nye/program/15.jpg": "a7ac",
	"./assets/img/nye/program/16.jpg": "fe7f",
	"./assets/img/nye/program/17.jpg": "acc5",
	"./assets/img/nye/program/18.jpg": "39f4",
	"./assets/img/nye/program/19.jpg": "8df1",
	"./assets/img/nye/program/2.jpg": "c06d",
	"./assets/img/nye/program/20.jpg": "4cf0",
	"./assets/img/nye/program/21.jpg": "4a74",
	"./assets/img/nye/program/22.jpg": "169f",
	"./assets/img/nye/program/23.jpg": "2ed0",
	"./assets/img/nye/program/24.jpg": "e2cf",
	"./assets/img/nye/program/3.jpg": "b1f1",
	"./assets/img/nye/program/4.jpg": "8f9e",
	"./assets/img/nye/program/5.jpg": "1bc9",
	"./assets/img/nye/program/6.jpg": "c085",
	"./assets/img/nye/program/7.jpg": "7a89",
	"./assets/img/nye/program/8.jpg": "ec0d",
	"./assets/img/nye/program/9.jpg": "7625",
	"./assets/img/nye/restaurant-price_bg.svg": "ad34",
	"./assets/img/nye/restaurant-price_en.svg": "312f",
	"./assets/img/nye/restaurant_bg.svg": "b464",
	"./assets/img/nye/restaurant_en.svg": "8361",
	"./assets/img/offers/OLD/202200/bg.jpg": "be87",
	"./assets/img/offers/OLD/202200/svg_bg.svg": "ec47",
	"./assets/img/offers/OLD/202200/svg_en.svg": "da51",
	"./assets/img/offers/OLD/202200/table1-bg.svg": "5435",
	"./assets/img/offers/OLD/202200/table1-en.svg": "a8ce",
	"./assets/img/offers/OLD/202201/bg.jpg": "62a0",
	"./assets/img/offers/OLD/202201/svg_bg.svg": "8fe5",
	"./assets/img/offers/OLD/202201/svg_en.svg": "5c72",
	"./assets/img/offers/OLD/202201/table1-bg.svg": "8d26",
	"./assets/img/offers/OLD/202201/table1-en.svg": "668f",
	"./assets/img/offers/OLD/202202/bg.jpg": "b21b",
	"./assets/img/offers/OLD/202202/svg_bg.svg": "01b5",
	"./assets/img/offers/OLD/202202/svg_en.svg": "8467",
	"./assets/img/offers/OLD/202202/table1-bg.svg": "3ede",
	"./assets/img/offers/OLD/202202/table1-en.svg": "e17d",
	"./assets/img/offers/OLD/december-escape/bg.jpg": "58a5",
	"./assets/img/offers/OLD/december-escape/svg_bg.svg": "80e8",
	"./assets/img/offers/OLD/december-escape/svg_en.svg": "9fe8",
	"./assets/img/offers/OLD/december-escape/table1-bg.svg": "a082",
	"./assets/img/offers/OLD/december-escape/table1-en.svg": "c495",
	"./assets/img/offers/OLD/march-escape-2024/1.jpg": "c9fc",
	"./assets/img/offers/OLD/march-escape-2024/10.jpg": "6387",
	"./assets/img/offers/OLD/march-escape-2024/11.jpg": "682d",
	"./assets/img/offers/OLD/march-escape-2024/12.jpg": "02d1",
	"./assets/img/offers/OLD/march-escape-2024/13.jpg": "9607",
	"./assets/img/offers/OLD/march-escape-2024/14.jpg": "648f",
	"./assets/img/offers/OLD/march-escape-2024/15.jpg": "9c1f",
	"./assets/img/offers/OLD/march-escape-2024/16.jpg": "32af",
	"./assets/img/offers/OLD/march-escape-2024/17.jpg": "ef98",
	"./assets/img/offers/OLD/march-escape-2024/2.jpg": "cb24",
	"./assets/img/offers/OLD/march-escape-2024/3.jpg": "4607",
	"./assets/img/offers/OLD/march-escape-2024/4.jpg": "158e",
	"./assets/img/offers/OLD/march-escape-2024/5.jpg": "b0cca",
	"./assets/img/offers/OLD/march-escape-2024/6.jpg": "ae66",
	"./assets/img/offers/OLD/march-escape-2024/8.jpg": "2f57",
	"./assets/img/offers/OLD/march-escape-2024/bg.jpg": "9b4d",
	"./assets/img/offers/OLD/march-escape-2024/svg_bg.svg": "79ce",
	"./assets/img/offers/OLD/march-escape-2024/svg_en.svg": "e323",
	"./assets/img/offers/OLD/march-escape-2024/table1-bg.svg": "9e6e",
	"./assets/img/offers/OLD/march-escape-2024/table1-en.svg": "6628",
	"./assets/img/offers/OLD/mountain-relax-2023/bg.jpg": "0e52",
	"./assets/img/offers/OLD/mountain-relax-2023/svg_bg.svg": "2c7f",
	"./assets/img/offers/OLD/mountain-relax-2023/svg_en.svg": "dd1d",
	"./assets/img/offers/OLD/mountain-relax-2023/table1-bg.svg": "5cc0",
	"./assets/img/offers/OLD/mountain-relax-2023/table1-en.svg": "5bc4",
	"./assets/img/offers/OLD/mountain-spa-relax/1.jpg": "4438",
	"./assets/img/offers/OLD/mountain-spa-relax/10.jpg": "36bf",
	"./assets/img/offers/OLD/mountain-spa-relax/11.jpg": "82e3",
	"./assets/img/offers/OLD/mountain-spa-relax/12.jpg": "06a8",
	"./assets/img/offers/OLD/mountain-spa-relax/13.jpg": "65ab",
	"./assets/img/offers/OLD/mountain-spa-relax/14.jpg": "e880",
	"./assets/img/offers/OLD/mountain-spa-relax/15.jpg": "06fb",
	"./assets/img/offers/OLD/mountain-spa-relax/16.jpg": "3c17",
	"./assets/img/offers/OLD/mountain-spa-relax/17.jpg": "7205",
	"./assets/img/offers/OLD/mountain-spa-relax/18.jpg": "9686",
	"./assets/img/offers/OLD/mountain-spa-relax/19.jpg": "5097",
	"./assets/img/offers/OLD/mountain-spa-relax/2.jpg": "ba1f",
	"./assets/img/offers/OLD/mountain-spa-relax/20.jpg": "9ac9",
	"./assets/img/offers/OLD/mountain-spa-relax/21.jpg": "d254",
	"./assets/img/offers/OLD/mountain-spa-relax/22.jpg": "07b8",
	"./assets/img/offers/OLD/mountain-spa-relax/23.jpg": "61f6",
	"./assets/img/offers/OLD/mountain-spa-relax/24.jpg": "cfc3",
	"./assets/img/offers/OLD/mountain-spa-relax/25.jpg": "8432",
	"./assets/img/offers/OLD/mountain-spa-relax/3.jpg": "642a",
	"./assets/img/offers/OLD/mountain-spa-relax/4.jpg": "7fba",
	"./assets/img/offers/OLD/mountain-spa-relax/5.jpg": "304e",
	"./assets/img/offers/OLD/mountain-spa-relax/6.jpg": "6acc",
	"./assets/img/offers/OLD/mountain-spa-relax/7.jpg": "8697",
	"./assets/img/offers/OLD/mountain-spa-relax/8.jpg": "6222",
	"./assets/img/offers/OLD/mountain-spa-relax/9.jpg": "b0d9",
	"./assets/img/offers/OLD/mountain-spa-relax/bg.jpg": "12c2",
	"./assets/img/offers/OLD/mountain-spa-relax/svg_bg.svg": "46b5",
	"./assets/img/offers/OLD/mountain-spa-relax/svg_en.svg": "16eb",
	"./assets/img/offers/OLD/mountain-spa-relax/table1-bg.svg": "c961",
	"./assets/img/offers/OLD/mountain-spa-relax/table1-en.svg": "fb98",
	"./assets/img/offers/OLD/ski-packages-breakfast&dinner-included/bg.jpg": "85f7",
	"./assets/img/offers/OLD/ski-packages-breakfast&dinner-included/svg_bg.svg": "8cbb",
	"./assets/img/offers/OLD/ski-packages-breakfast&dinner-included/svg_en.svg": "bef3",
	"./assets/img/offers/OLD/ski-packages-breakfast&dinner-included/table1-bg.svg": "04ca",
	"./assets/img/offers/OLD/ski-packages-breakfast&dinner-included/table1-en.svg": "beea",
	"./assets/img/offers/OLD/ski-packages-breakfast-included/bg.jpg": "814b",
	"./assets/img/offers/OLD/ski-packages-breakfast-included/svg_bg.svg": "a88c",
	"./assets/img/offers/OLD/ski-packages-breakfast-included/svg_en.svg": "5438",
	"./assets/img/offers/OLD/ski-packages-breakfast-included/table1-bg.svg": "1d51",
	"./assets/img/offers/OLD/ski-packages-breakfast-included/table1-en.svg": "1814",
	"./assets/img/offers/OLD/yoga-retreat-offer/1.jpg": "84e2",
	"./assets/img/offers/OLD/yoga-retreat-offer/bg.jpg": "05e0",
	"./assets/img/offers/OLD/yoga-retreat-offer/svg_bg.svg": "a8b2",
	"./assets/img/offers/OLD/yoga-retreat-offer/svg_en.svg": "3807",
	"./assets/img/offers/OLD/yoga-retreat-offer/table1-bg.svg": "0f10",
	"./assets/img/offers/OLD/yoga-retreat-offer/table1-en.svg": "71ee",
	"./assets/img/offers/easter-2025/bg.jpg": "a484",
	"./assets/img/offers/easter-2025/svg_bg.svg": "1a63",
	"./assets/img/offers/easter-2025/svg_en.svg": "3bac",
	"./assets/img/offers/easter-2025/table1-bg.svg": "5d47",
	"./assets/img/offers/easter-2025/table1-en.svg": "fe26",
	"./assets/img/offers/mountain-relax-2024/bg.jpg": "622f",
	"./assets/img/offers/mountain-relax-2024/svg_bg.svg": "9eaa",
	"./assets/img/offers/mountain-relax-2024/svg_en.svg": "3498",
	"./assets/img/offers/mountain-relax-2024/table1-bg.svg": "ee3a",
	"./assets/img/offers/mountain-relax-2024/table1-en.svg": "6c38",
	"./assets/img/offers/mountain-relax-2025/bg.jpg": "120a",
	"./assets/img/offers/mountain-relax-2025/svg_bg.svg": "5e1d",
	"./assets/img/offers/mountain-relax-2025/svg_en.svg": "9e00",
	"./assets/img/offers/mountain-relax-2025/table1-bg.svg": "1215",
	"./assets/img/offers/mountain-relax-2025/table1-en.svg": "ce12",
	"./assets/img/offers/mountain-summer-aquapark-2025/1.jpg": "be25",
	"./assets/img/offers/mountain-summer-aquapark-2025/10.jpg": "03d2",
	"./assets/img/offers/mountain-summer-aquapark-2025/11.jpg": "592f",
	"./assets/img/offers/mountain-summer-aquapark-2025/12.jpg": "e082",
	"./assets/img/offers/mountain-summer-aquapark-2025/13.jpg": "a008",
	"./assets/img/offers/mountain-summer-aquapark-2025/14.jpg": "73a7",
	"./assets/img/offers/mountain-summer-aquapark-2025/15.jpg": "b405",
	"./assets/img/offers/mountain-summer-aquapark-2025/16.jpg": "582e",
	"./assets/img/offers/mountain-summer-aquapark-2025/17.jpg": "e028",
	"./assets/img/offers/mountain-summer-aquapark-2025/2.jpg": "b1b8",
	"./assets/img/offers/mountain-summer-aquapark-2025/3.jpg": "c5fd",
	"./assets/img/offers/mountain-summer-aquapark-2025/4.jpg": "6d6f",
	"./assets/img/offers/mountain-summer-aquapark-2025/5.jpg": "8c0f",
	"./assets/img/offers/mountain-summer-aquapark-2025/6.jpg": "6346",
	"./assets/img/offers/mountain-summer-aquapark-2025/8.jpg": "e51d",
	"./assets/img/offers/mountain-summer-aquapark-2025/bg.jpg": "ee3d",
	"./assets/img/offers/mountain-summer-aquapark-2025/svg_bg.svg": "4ee3",
	"./assets/img/offers/mountain-summer-aquapark-2025/svg_en.svg": "cd7f",
	"./assets/img/offers/mountain-summer-aquapark-2025/table1-bg.svg": "d9e6",
	"./assets/img/offers/mountain-summer-aquapark-2025/table1-en.svg": "7c90",
	"./assets/img/offers/renovation-2025/1.jpg": "fa08",
	"./assets/img/offers/renovation-2025/15.jpg": "2c6d",
	"./assets/img/offers/renovation-2025/19.jpg": "032e",
	"./assets/img/offers/renovation-2025/2.jpg": "a0be",
	"./assets/img/offers/renovation-2025/2025.mp4": "ef91",
	"./assets/img/offers/renovation-2025/3.jpg": "dd9c",
	"./assets/img/offers/renovation-2025/bg.jpg": "8e51",
	"./assets/img/offers/renovation-2025/prices_bg.svg": "4a6c",
	"./assets/img/offers/renovation-2025/prices_en.svg": "0467",
	"./assets/img/offers/renovation-2025/svg_bg.svg": "fed7",
	"./assets/img/offers/renovation-2025/svg_en.svg": "af72",
	"./assets/img/offers/svg_bg.svg": "6985",
	"./assets/img/offers/svg_en.svg": "33e0",
	"./assets/img/offers/vipski/prices_bg.svg": "19d4",
	"./assets/img/offers/vipski/prices_en.svg": "4b1d",
	"./assets/img/offers/vipski/svg_bg.svg": "0fae",
	"./assets/img/offers/vipski/svg_en.svg": "e113",
	"./assets/img/offers/vipski/vipski.jpg": "6cb9",
	"./assets/img/offers/vipski/vipski.mp4": "995b",
	"./assets/img/offers/vipski/vipski2.jpg": "321e",
	"./assets/img/offers/winter-escape-2025/1.jpg": "e55e",
	"./assets/img/offers/winter-escape-2025/10.jpg": "21eb",
	"./assets/img/offers/winter-escape-2025/11.jpg": "b160",
	"./assets/img/offers/winter-escape-2025/12.jpg": "8429",
	"./assets/img/offers/winter-escape-2025/13.jpg": "3d38",
	"./assets/img/offers/winter-escape-2025/14.jpg": "25a1",
	"./assets/img/offers/winter-escape-2025/15.jpg": "8426",
	"./assets/img/offers/winter-escape-2025/16.jpg": "6dc9",
	"./assets/img/offers/winter-escape-2025/17.jpg": "31c3",
	"./assets/img/offers/winter-escape-2025/2.jpg": "00eb",
	"./assets/img/offers/winter-escape-2025/3.jpg": "104de",
	"./assets/img/offers/winter-escape-2025/4.jpg": "2a98",
	"./assets/img/offers/winter-escape-2025/5.jpg": "87f3",
	"./assets/img/offers/winter-escape-2025/6.jpg": "744b",
	"./assets/img/offers/winter-escape-2025/7.jpg": "7647",
	"./assets/img/offers/winter-escape-2025/8.jpg": "e8cb",
	"./assets/img/offers/winter-escape-2025/9.jpg": "df94",
	"./assets/img/offers/winter-escape-2025/bg.jpg": "785b",
	"./assets/img/offers/winter-escape-2025/svg_bg.svg": "8a08",
	"./assets/img/offers/winter-escape-2025/svg_en.svg": "abac",
	"./assets/img/offers/winter-escape-2025/table1-bg.svg": "a22e",
	"./assets/img/offers/winter-escape-2025/table1-en.svg": "8749",
	"./assets/img/r.svg": "756e",
	"./assets/img/restaurant/bg.jpg": "6598",
	"./assets/img/restaurant/plate.png": "0c78",
	"./assets/img/restaurant/s1-1.jpg": "9e74",
	"./assets/img/restaurant/s1-2.jpg": "4d50",
	"./assets/img/restaurant/s1-3.jpg": "16d6",
	"./assets/img/restaurant/s2-1.jpg": "97bb",
	"./assets/img/restaurant/s2-2.jpg": "25d0",
	"./assets/img/restaurant/s2-3.jpg": "79ab",
	"./assets/img/restaurant/s3-1.jpg": "8d17",
	"./assets/img/restaurant/s3-2.jpg": "6705",
	"./assets/img/restaurant/s3-3.jpg": "4291",
	"./assets/img/restaurant/s4-1.jpg": "2e29",
	"./assets/img/restaurant/s4-2.jpg": "e7b2",
	"./assets/img/restaurant/s4-3.jpg": "7180",
	"./assets/img/restaurant/svg_bg.svg": "e89a",
	"./assets/img/restaurant/svg_en.svg": "e401",
	"./assets/img/right.svg": "50d7",
	"./assets/img/right_white.svg": "4dcb",
	"./assets/img/rooms/1/a1.jpg": "45bc",
	"./assets/img/rooms/1/a2.jpg": "c038",
	"./assets/img/rooms/1/a3.jpg": "22e2",
	"./assets/img/rooms/1/bg.jpg": "3e1a",
	"./assets/img/rooms/1/g0.jpg": "f3c0",
	"./assets/img/rooms/1/g1.jpg": "5469",
	"./assets/img/rooms/1/g2.jpg": "6738",
	"./assets/img/rooms/1/g3.jpg": "ef8b",
	"./assets/img/rooms/1/g4.jpg": "5460",
	"./assets/img/rooms/1/g5.jpg": "13bc",
	"./assets/img/rooms/1/g6.jpg": "b8ac",
	"./assets/img/rooms/1/prices_bg.svg": "1a64",
	"./assets/img/rooms/1/prices_en.svg": "b320",
	"./assets/img/rooms/1/svg_bg.svg": "0f41",
	"./assets/img/rooms/1/svg_en.svg": "480f",
	"./assets/img/rooms/10/a0.jpg": "ce33",
	"./assets/img/rooms/10/a1.jpg": "1736",
	"./assets/img/rooms/10/a2.jpg": "a239",
	"./assets/img/rooms/10/a3.jpg": "bfa3",
	"./assets/img/rooms/10/bg.jpg": "3bf8",
	"./assets/img/rooms/10/g0.jpg": "d915",
	"./assets/img/rooms/10/g1.jpg": "1ca2",
	"./assets/img/rooms/10/g10.jpg": "d98b",
	"./assets/img/rooms/10/g11.jpg": "e9b6",
	"./assets/img/rooms/10/g12.jpg": "34e7",
	"./assets/img/rooms/10/g13.jpg": "a671",
	"./assets/img/rooms/10/g14.jpg": "db2f",
	"./assets/img/rooms/10/g2.jpg": "ccf3",
	"./assets/img/rooms/10/g3.jpg": "4b0c",
	"./assets/img/rooms/10/g4.jpg": "1e12",
	"./assets/img/rooms/10/g5.jpg": "4c34",
	"./assets/img/rooms/10/g6.jpg": "83cd",
	"./assets/img/rooms/10/g7.jpg": "b345",
	"./assets/img/rooms/10/g8.jpg": "5053",
	"./assets/img/rooms/10/g9.jpg": "6407",
	"./assets/img/rooms/10/prices_bg.svg": "ad6d",
	"./assets/img/rooms/10/prices_en.svg": "f7db",
	"./assets/img/rooms/10/svg_bg.svg": "d207",
	"./assets/img/rooms/10/svg_en.svg": "56c5",
	"./assets/img/rooms/2/a1.jpg": "160f",
	"./assets/img/rooms/2/a2.jpg": "513b",
	"./assets/img/rooms/2/a3.jpg": "f497",
	"./assets/img/rooms/2/bg.jpg": "87b5",
	"./assets/img/rooms/2/g0.jpg": "6482",
	"./assets/img/rooms/2/g1.jpg": "e9ca",
	"./assets/img/rooms/2/g2.jpg": "c78f",
	"./assets/img/rooms/2/g3.jpg": "86a6",
	"./assets/img/rooms/2/g4.jpg": "4d88",
	"./assets/img/rooms/2/g5.jpg": "ae86",
	"./assets/img/rooms/2/g6.jpg": "68d7",
	"./assets/img/rooms/2/prices_bg.svg": "c6ca",
	"./assets/img/rooms/2/prices_en.svg": "f69f3",
	"./assets/img/rooms/2/svg_bg.svg": "f435",
	"./assets/img/rooms/2/svg_en.svg": "4249",
	"./assets/img/rooms/3/Group 525.svg": "561d",
	"./assets/img/rooms/3/a1.jpg": "0bfd",
	"./assets/img/rooms/3/a2.jpg": "024a",
	"./assets/img/rooms/3/a3.jpg": "501e",
	"./assets/img/rooms/3/bg.jpg": "a010",
	"./assets/img/rooms/3/g0.jpg": "b1ba",
	"./assets/img/rooms/3/g1.jpg": "f340",
	"./assets/img/rooms/3/g10.jpg": "d93c",
	"./assets/img/rooms/3/g11.jpg": "90fb",
	"./assets/img/rooms/3/g2.jpg": "7f99",
	"./assets/img/rooms/3/g3.jpg": "a9c4",
	"./assets/img/rooms/3/g4.jpg": "3715",
	"./assets/img/rooms/3/g5.jpg": "4144",
	"./assets/img/rooms/3/g6.jpg": "944d",
	"./assets/img/rooms/3/g7.jpg": "bd1b",
	"./assets/img/rooms/3/g8.jpg": "cba9",
	"./assets/img/rooms/3/g9.jpg": "7de9",
	"./assets/img/rooms/3/svg_bg.svg": "08c0",
	"./assets/img/rooms/3/svg_en.svg": "0f05",
	"./assets/img/rooms/4/a1.jpg": "5d7e",
	"./assets/img/rooms/4/a2.jpg": "c9d6",
	"./assets/img/rooms/4/a3.jpg": "f9b9",
	"./assets/img/rooms/4/bg.jpg": "c34d",
	"./assets/img/rooms/4/g0.jpg": "d53e",
	"./assets/img/rooms/4/g1.jpg": "9a9f",
	"./assets/img/rooms/4/g2.jpg": "0661",
	"./assets/img/rooms/4/g3.jpg": "697e",
	"./assets/img/rooms/4/g4.jpg": "a54a",
	"./assets/img/rooms/4/g5.jpg": "84e5",
	"./assets/img/rooms/4/g6.jpg": "575e",
	"./assets/img/rooms/4/g7.jpg": "17d7",
	"./assets/img/rooms/4/svg_bg.svg": "1378",
	"./assets/img/rooms/4/svg_en.svg": "5bd4",
	"./assets/img/rooms/5/a1.jpg": "0e43",
	"./assets/img/rooms/5/a2.jpg": "6da5",
	"./assets/img/rooms/5/a3.jpg": "b050",
	"./assets/img/rooms/5/bg.jpg": "6c37",
	"./assets/img/rooms/5/g0.jpg": "9eda",
	"./assets/img/rooms/5/g1.jpg": "478c",
	"./assets/img/rooms/5/g10.jpg": "dfc6",
	"./assets/img/rooms/5/g11.jpg": "e46d",
	"./assets/img/rooms/5/g2.jpg": "6998",
	"./assets/img/rooms/5/g3.jpg": "9fca",
	"./assets/img/rooms/5/g4.jpg": "7ac8",
	"./assets/img/rooms/5/g5.jpg": "a195",
	"./assets/img/rooms/5/g6.jpg": "5fb3",
	"./assets/img/rooms/5/g7.jpg": "75bb",
	"./assets/img/rooms/5/g8.jpg": "fbfe",
	"./assets/img/rooms/5/g9.jpg": "ed46",
	"./assets/img/rooms/5/svg_bg.svg": "ef6e",
	"./assets/img/rooms/5/svg_en.svg": "362e",
	"./assets/img/rooms/6/a1.jpg": "7661",
	"./assets/img/rooms/6/a2.jpg": "327d",
	"./assets/img/rooms/6/a3.jpg": "3e91",
	"./assets/img/rooms/6/bg.jpg": "ff63",
	"./assets/img/rooms/6/g0.jpg": "7b41",
	"./assets/img/rooms/6/g1.jpg": "7171",
	"./assets/img/rooms/6/g2.jpg": "2414",
	"./assets/img/rooms/6/g3.jpg": "165f",
	"./assets/img/rooms/6/g4.jpg": "d038",
	"./assets/img/rooms/6/g5.jpg": "2dcc",
	"./assets/img/rooms/6/g6.jpg": "f744",
	"./assets/img/rooms/6/g7.jpg": "5254",
	"./assets/img/rooms/6/g8.jpg": "0c11",
	"./assets/img/rooms/6/prices_bg.svg": "3157",
	"./assets/img/rooms/6/prices_en.svg": "5745",
	"./assets/img/rooms/6/svg_bg.svg": "e2ca",
	"./assets/img/rooms/6/svg_en.svg": "2119",
	"./assets/img/rooms/7/a1.jpg": "2e53",
	"./assets/img/rooms/7/a2.jpg": "b410",
	"./assets/img/rooms/7/a3.jpg": "98a6",
	"./assets/img/rooms/7/bg.jpg": "7c13",
	"./assets/img/rooms/7/g0.jpg": "adb8",
	"./assets/img/rooms/7/g1.jpg": "33c1",
	"./assets/img/rooms/7/g10.jpg": "8c04",
	"./assets/img/rooms/7/g2.jpg": "468d",
	"./assets/img/rooms/7/g3.jpg": "3042",
	"./assets/img/rooms/7/g4.jpg": "2ebd",
	"./assets/img/rooms/7/g5.jpg": "3f09",
	"./assets/img/rooms/7/g6.jpg": "d6d7",
	"./assets/img/rooms/7/g7.jpg": "fc15",
	"./assets/img/rooms/7/g8.jpg": "57fd",
	"./assets/img/rooms/7/g9.jpg": "0202",
	"./assets/img/rooms/7/svg_bg.svg": "a3d1",
	"./assets/img/rooms/7/svg_en.svg": "f5cf",
	"./assets/img/rooms/8/a1.jpg": "9c96",
	"./assets/img/rooms/8/a2.jpg": "6fbe",
	"./assets/img/rooms/8/a3.jpg": "b0a8",
	"./assets/img/rooms/8/bg.jpg": "6ebd",
	"./assets/img/rooms/8/g0.jpg": "3b68",
	"./assets/img/rooms/8/g1.jpg": "f005",
	"./assets/img/rooms/8/g2.jpg": "c3b9",
	"./assets/img/rooms/8/g3.jpg": "34f7",
	"./assets/img/rooms/8/g4.jpg": "f142",
	"./assets/img/rooms/8/g5.jpg": "bc0a",
	"./assets/img/rooms/8/svg_bg.svg": "71f2",
	"./assets/img/rooms/8/svg_en.svg": "afaf",
	"./assets/img/rooms/9/a1.jpg": "6c6c",
	"./assets/img/rooms/9/a2.jpg": "57ac",
	"./assets/img/rooms/9/a3.jpg": "8070",
	"./assets/img/rooms/9/bg.jpg": "300e",
	"./assets/img/rooms/9/g0.jpg": "8fec",
	"./assets/img/rooms/9/g1.jpg": "7b3c",
	"./assets/img/rooms/9/g10.jpg": "bdaa",
	"./assets/img/rooms/9/g2.jpg": "b6e3",
	"./assets/img/rooms/9/g3.jpg": "8188",
	"./assets/img/rooms/9/g4.jpg": "807b",
	"./assets/img/rooms/9/g5.jpg": "ef4d",
	"./assets/img/rooms/9/g6.jpg": "5917",
	"./assets/img/rooms/9/g7.jpg": "befd",
	"./assets/img/rooms/9/g8.jpg": "73ba",
	"./assets/img/rooms/9/g9.jpg": "87de",
	"./assets/img/rooms/9/svg_bg.svg": "4df5",
	"./assets/img/rooms/9/svg_en.svg": "3885",
	"./assets/img/rooms/a1.jpg": "8452",
	"./assets/img/rooms/a2.jpg": "ad2d",
	"./assets/img/rooms/a3.jpg": "abc3",
	"./assets/img/rooms/features/o1.svg": "071f",
	"./assets/img/rooms/features/o2.svg": "35c5",
	"./assets/img/rooms/features/o3.svg": "7614",
	"./assets/img/rooms/features/o4.svg": "21b7",
	"./assets/img/rooms/features/o5.svg": "f27e",
	"./assets/img/rooms/features/o6.svg": "afef",
	"./assets/img/rooms/features/o7.svg": "cf18",
	"./assets/img/rooms/features/o8.svg": "d75f",
	"./assets/img/rooms/features/r1.svg": "c0e4",
	"./assets/img/rooms/features/r2.svg": "2963",
	"./assets/img/rooms/features/r3.svg": "97ed",
	"./assets/img/rooms/features/r4.svg": "552b",
	"./assets/img/rooms/features/r5.svg": "d9b5e",
	"./assets/img/rooms/features/r6.svg": "02ef",
	"./assets/img/rooms/features/r7.svg": "f7a5",
	"./assets/img/rooms/features/r8.svg": "9343",
	"./assets/img/rooms/g1.jpg": "7ece",
	"./assets/img/rooms/g2.jpg": "2be8",
	"./assets/img/rooms/svg_bg.svg": "1f77",
	"./assets/img/rooms/svg_en.svg": "683c",
	"./assets/img/scroll_h.svg": "2e0a",
	"./assets/img/scroll_t.svg": "fc8c",
	"./assets/img/services/1/bg.jpg": "12c1",
	"./assets/img/services/1/svg.svg": "2ec6",
	"./assets/img/services/2/bg.jpg": "2d94",
	"./assets/img/services/2/svg.svg": "92c8",
	"./assets/img/services/3/bg.jpg": "9484",
	"./assets/img/services/3/svg.svg": "dc29",
	"./assets/img/services/svg_bg.svg": "e135",
	"./assets/img/services/svg_en.svg": "1251",
	"./assets/img/showcase/back.svg": "1595",
	"./assets/img/showcase/check_1.png": "1089",
	"./assets/img/showcase/check_10.png": "0323",
	"./assets/img/showcase/check_11.png": "6ba7",
	"./assets/img/showcase/check_12.png": "b33e",
	"./assets/img/showcase/check_13.png": "915d",
	"./assets/img/showcase/check_14.png": "696f",
	"./assets/img/showcase/check_15.png": "5bee",
	"./assets/img/showcase/check_2.png": "38b1",
	"./assets/img/showcase/check_3.png": "123c",
	"./assets/img/showcase/check_4.png": "89c5",
	"./assets/img/showcase/check_5.png": "642c",
	"./assets/img/showcase/check_6.png": "e42c",
	"./assets/img/showcase/check_7.png": "78a9",
	"./assets/img/showcase/check_8.png": "b4aa",
	"./assets/img/showcase/check_9.png": "c0f7",
	"./assets/img/showcase/glr_bg.svg": "bc01",
	"./assets/img/showcase/glr_en.svg": "7e1c",
	"./assets/img/showcase/info_bg.svg": "5756",
	"./assets/img/showcase/info_en.svg": "bd84",
	"./assets/img/showcase/inq_bg.svg": "943e",
	"./assets/img/showcase/inq_en.svg": "1668",
	"./assets/img/showcase/mountain.svg": "89a2",
	"./assets/img/showcase/superior.svg": "7379",
	"./assets/img/showcases.jpg": "802c",
	"./assets/img/spa-o/s1-1.jpg": "284f",
	"./assets/img/spa-o/s1-2.jpg": "bc03",
	"./assets/img/spa-o/s1-3.jpg": "6a77",
	"./assets/img/spa-o/s2-1.jpg": "a01c",
	"./assets/img/spa-o/s2-2.jpg": "be6c",
	"./assets/img/spa-o/s2-3.jpg": "09e0",
	"./assets/img/spa-o/s3-1.jpg": "210f",
	"./assets/img/spa-o/s3-2.jpg": "acbd",
	"./assets/img/spa-o/s3-3.jpg": "865b",
	"./assets/img/spa-o/s4-1.jpg": "7541",
	"./assets/img/spa-o/s4-2.jpg": "563e",
	"./assets/img/spa-o/s4-3.jpg": "7e3c",
	"./assets/img/spa-o/sp1.jpg": "a7ec",
	"./assets/img/spa-o/sp2.jpg": "d0e0",
	"./assets/img/spa-o/sp3.jpg": "af75",
	"./assets/img/spa-o/svg_bg.svg": "e9f3",
	"./assets/img/spa-o/svg_en.svg": "5517",
	"./assets/img/spa-s/s1-1.jpg": "1f56",
	"./assets/img/spa-s/s1-2.jpg": "0d7c",
	"./assets/img/spa-s/s1-3.jpg": "e8a0",
	"./assets/img/spa-s/s2-1.jpg": "291b",
	"./assets/img/spa-s/s2-2.jpg": "35de",
	"./assets/img/spa-s/s2-3.jpg": "957c",
	"./assets/img/spa-s/s3-1.jpg": "c1dc",
	"./assets/img/spa-s/s3-2.jpg": "1f1a",
	"./assets/img/spa-s/s3-3.jpg": "d7a4",
	"./assets/img/spa-s/s4-1.jpg": "2b15",
	"./assets/img/spa-s/s4-2.jpg": "02ac",
	"./assets/img/spa-s/s4-3.jpg": "059d",
	"./assets/img/spa-s/svg_bg.svg": "d27a",
	"./assets/img/spa-s/svg_en.svg": "f133",
	"./assets/img/spa-w/s1-1.jpg": "6077",
	"./assets/img/spa-w/s1-2.jpg": "e7c7",
	"./assets/img/spa-w/s1-3.jpg": "e507",
	"./assets/img/spa-w/s2-1.jpg": "94fc",
	"./assets/img/spa-w/s2-2.jpg": "b6bc",
	"./assets/img/spa-w/s2-3.jpg": "58dd",
	"./assets/img/spa-w/s3-1.jpg": "c5f8",
	"./assets/img/spa-w/s3-2.jpg": "2c11",
	"./assets/img/spa-w/s3-3.jpg": "a7dc",
	"./assets/img/spa-w/s4-1.jpg": "29e9",
	"./assets/img/spa-w/s4-2.jpg": "ea1c",
	"./assets/img/spa-w/s4-3.jpg": "6bb6",
	"./assets/img/spa-w/s5-1.jpg": "19ae",
	"./assets/img/spa-w/s5-2.jpg": "0dd0",
	"./assets/img/spa-w/s5-3.jpg": "7972",
	"./assets/img/spa-w/sp3.jpg": "b03e",
	"./assets/img/spa-w/svg_bg.svg": "c98a",
	"./assets/img/spa-w/svg_en.svg": "f58d",
	"./assets/img/spa/bg.jpg": "b649",
	"./assets/img/spa/spa-services/m1_t1_bg.svg": "4fe2",
	"./assets/img/spa/spa-services/m1_t1_en.svg": "1662",
	"./assets/img/spa/spa-services/m1_t2_bg.svg": "21dc",
	"./assets/img/spa/spa-services/m1_t2_en.svg": "2150",
	"./assets/img/spa/spa-services/m2_t1_bg.svg": "fd128",
	"./assets/img/spa/spa-services/m2_t1_en.svg": "1356",
	"./assets/img/spa/spa-services/m2_t2_bg.svg": "1bf9",
	"./assets/img/spa/spa-services/m2_t2_en.svg": "6830",
	"./assets/img/spa/spa-services/m3_t1_bg.svg": "b24a",
	"./assets/img/spa/spa-services/m3_t1_en.svg": "4355",
	"./assets/img/spa/spa-services/m3_t2_bg.svg": "d8ce",
	"./assets/img/spa/spa-services/m3_t2_en.svg": "18d2",
	"./assets/img/spa/spa-services/m4_t1_bg.svg": "bedb",
	"./assets/img/spa/spa-services/m4_t1_en.svg": "cbff",
	"./assets/img/spa/spa-services/m4_t2_bg.svg": "160e",
	"./assets/img/spa/spa-services/m4_t2_en.svg": "7724",
	"./assets/img/spa/spa-services/m5_t1_bg.svg": "e7dc",
	"./assets/img/spa/spa-services/m5_t1_en.svg": "563f",
	"./assets/img/spa/spa-services/m5_t2_bg.svg": "c68c",
	"./assets/img/spa/spa-services/m5_t2_en.svg": "54c8",
	"./assets/img/spa/spa1.jpg": "b9b7",
	"./assets/img/spa/spa2.jpg": "c374",
	"./assets/img/spa/spa3.jpg": "d9cf",
	"./assets/img/spa/svg_bg.svg": "e1dc",
	"./assets/img/spa/svg_en.svg": "2f3a",
	"./assets/img/terms/terms.jpg": "fdb1",
	"./assets/img/terms/terms_bg.svg": "39ee",
	"./assets/img/terms/terms_en.svg": "4b75",
	"./assets/img/weather/01d.png": "a211",
	"./assets/img/weather/01n.png": "1e42",
	"./assets/img/weather/02d.png": "25fd",
	"./assets/img/weather/02n.png": "ab0b",
	"./assets/img/weather/03d.png": "5290",
	"./assets/img/weather/03n.png": "bc5e",
	"./assets/img/weather/04d.png": "795c",
	"./assets/img/weather/04n.png": "d12b",
	"./assets/img/weather/09d.png": "2055",
	"./assets/img/weather/09n.png": "b679",
	"./assets/img/weather/10d.png": "f3f7",
	"./assets/img/weather/10n.png": "ba23",
	"./assets/img/weather/11d.png": "d40e",
	"./assets/img/weather/11n.png": "c783",
	"./assets/img/weather/13d.png": "697d",
	"./assets/img/weather/13n.png": "e1ac",
	"./assets/img/weather/50d.png": "6243",
	"./assets/img/weather/50n.png": "7923",
	"./components/Button": "2a7d",
	"./components/Button.vue": "2a7d",
	"./components/ButtonSmaller": "c5c8",
	"./components/ButtonSmaller.vue": "c5c8",
	"./components/Footer": "fd2d",
	"./components/Footer.vue": "fd2d",
	"./components/FooterAdditional": "97a1",
	"./components/FooterAdditional.vue": "97a1",
	"./components/FooterGallery": "2092",
	"./components/FooterGallery.vue": "2092",
	"./components/GDPR": "95f2",
	"./components/GDPR.vue": "95f2",
	"./components/Header": "0418",
	"./components/Header.vue": "0418",
	"./components/Info": "8f33",
	"./components/Info.vue": "8f33",
	"./components/MobileDock": "c814",
	"./components/MobileDock.vue": "c814",
	"./components/Nav": "216c",
	"./components/Nav.vue": "216c",
	"./components/Parallax": "035a",
	"./components/Parallax.vue": "035a",
	"./components/ParallaxCarousel": "2822",
	"./components/ParallaxCarousel.vue": "2822",
	"./components/Preview": "e6c4",
	"./components/Preview.vue": "e6c4",
	"./components/PreviewCarousel": "1872",
	"./components/PreviewCarousel.vue": "1872",
	"./components/Reservation": "547e",
	"./components/Reservation.vue": "547e",
	"./components/Slideshow": "06cb",
	"./components/Slideshow.vue": "06cb",
	"./components/Tawkto": "0f0e",
	"./components/Tawkto.vue": "0f0e",
	"./locale/bg": "3565",
	"./locale/bg.json": "3565",
	"./locale/en": "0262",
	"./locale/en.json": "0262",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./scss/inner_about.scss": "3feb",
	"./scss/inner_page.scss": "da50",
	"./scss/mixins.scss": "8716",
	"./scss/showcase.scss": "28a4",
	"./scss/transition.scss": "83f7",
	"./scss/variables.scss": "b339",
	"./scss/vdp_datepicker.scss": "caa9",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/aem/aem": "f9bb",
	"./views/aem/aem.vue": "f9bb",
	"./views/aquapark/About": "c62c",
	"./views/aquapark/About.vue": "c62c",
	"./views/aquapark/Aquapark": "569e",
	"./views/aquapark/Aquapark.vue": "569e",
	"./views/aquapark/AquaparkModal": "0c41",
	"./views/aquapark/AquaparkModal.vue": "0c41",
	"./views/banya/About": "ee59",
	"./views/banya/About.vue": "ee59",
	"./views/banya/Banya": "6d40",
	"./views/banya/Banya.vue": "6d40",
	"./views/contacts/Contacts": "bf6f",
	"./views/contacts/Contacts.vue": "bf6f",
	"./views/form/Form": "23bd",
	"./views/form/Form.vue": "23bd",
	"./views/form/FormHalls": "706a",
	"./views/form/FormHalls.vue": "706a",
	"./views/gallery/Gallery": "5ed0",
	"./views/gallery/Gallery.vue": "5ed0",
	"./views/home/About": "d771",
	"./views/home/About.vue": "d771",
	"./views/home/Home": "b3d7",
	"./views/home/Home.vue": "b3d7",
	"./views/home/HomeModal": "673a",
	"./views/home/HomeModal.vue": "673a",
	"./views/kids/About": "6e80",
	"./views/kids/About.vue": "6e80",
	"./views/kids/Kids": "c6e5",
	"./views/kids/Kids.vue": "c6e5",
	"./views/loyalty/About": "bba0",
	"./views/loyalty/About.vue": "bba0",
	"./views/loyalty/Loyalty": "41b9",
	"./views/loyalty/Loyalty.vue": "41b9",
	"./views/menus/Menus": "3e25",
	"./views/menus/Menus.vue": "3e25",
	"./views/restaurant/About": "c51b",
	"./views/restaurant/About.vue": "c51b",
	"./views/restaurant/Restaurant": "f92a",
	"./views/restaurant/Restaurant.vue": "f92a",
	"./views/showcases/Features": "1a20",
	"./views/showcases/Features.vue": "1a20",
	"./views/showcases/Gallery": "2c28",
	"./views/showcases/Gallery.vue": "2c28",
	"./views/showcases/Inquiry": "1aef",
	"./views/showcases/Inquiry.vue": "1aef",
	"./views/showcases/InquiryCheckbox": "efff",
	"./views/showcases/InquiryCheckbox.vue": "efff",
	"./views/showcases/InquiryDropdown": "d0c9",
	"./views/showcases/InquiryDropdown.vue": "d0c9",
	"./views/showcases/InquiryInput": "374f",
	"./views/showcases/InquiryInput.vue": "374f",
	"./views/showcases/NewYear": "0729",
	"./views/showcases/NewYear.vue": "0729",
	"./views/showcases/NewYearB": "b99a",
	"./views/showcases/NewYearB.vue": "b99a",
	"./views/showcases/NewYearCarousel": "4dbe",
	"./views/showcases/NewYearCarousel.vue": "4dbe",
	"./views/showcases/NewYearR": "79c9",
	"./views/showcases/NewYearR.vue": "79c9",
	"./views/showcases/NotFound": "f68c",
	"./views/showcases/NotFound.vue": "f68c",
	"./views/showcases/Offer": "a218",
	"./views/showcases/Offer.vue": "a218",
	"./views/showcases/Showcase": "0dcc",
	"./views/showcases/Showcase.vue": "0dcc",
	"./views/showcases/Showcases": "d4fe",
	"./views/showcases/Showcases.vue": "d4fe",
	"./views/showcases/Suggestions": "3970",
	"./views/showcases/Suggestions.vue": "3970",
	"./views/showcases/Vipskipass": "18ee",
	"./views/showcases/Vipskipass.vue": "18ee",
	"./views/showcases/_Showcases": "fa54",
	"./views/showcases/_Showcases.vue": "fa54",
	"./views/showcases/old_offers": "1c40",
	"./views/showcases/old_offers.vue": "1c40",
	"./views/showcases/renovation-2025": "2ec2",
	"./views/showcases/renovation-2025.vue": "2ec2",
	"./views/spa/AboutOffers": "4f98",
	"./views/spa/AboutOffers.vue": "4f98",
	"./views/spa/AboutServices": "b406",
	"./views/spa/AboutServices.vue": "b406",
	"./views/spa/AboutWellnessAndFitness": "2ff8",
	"./views/spa/AboutWellnessAndFitness.vue": "2ff8",
	"./views/spa/SpaOffers": "6a93",
	"./views/spa/SpaOffers.vue": "6a93",
	"./views/spa/SpaServices": "7489",
	"./views/spa/SpaServices.vue": "7489",
	"./views/spa/SpaWellnessAndFitness": "0358",
	"./views/spa/SpaWellnessAndFitness.vue": "0358",
	"./views/terms/Terms": "d49b",
	"./views/terms/Terms.vue": "d49b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";